import { useEffect } from "react";
import { useApp } from "../../context/AppContext";

function upsertMeta(name, content, attr = "name") {
  if (!content) return;

  let element = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

export default function SEO({
  title,
  description,
  image,
  type = "website",
  canonical,
}) {
  const { siteSettingsMap, site } = useApp();

  useEffect(() => {
    const siteName =
      site?.name ||
      siteSettingsMap?.site_name ||
      "Solusi IoT Cerdas";

    const finalTitle = title ? `${title} | ${siteName}` : siteName;
    const finalDescription =
      description ||
      siteSettingsMap?.seo_description ||
      siteSettingsMap?.hero_subtitle ||
      "";
    const finalImage = image || site?.logo || "";
    const finalCanonical = canonical || window.location.href;

    document.title = finalTitle;

    upsertMeta("description", finalDescription);
    upsertMeta("og:title", finalTitle, "property");
    upsertMeta("og:description", finalDescription, "property");
    upsertMeta("og:type", type, "property");
    upsertMeta("og:url", finalCanonical, "property");

    if (finalImage) {
      upsertMeta("og:image", finalImage, "property");
      upsertMeta("twitter:image", finalImage, "name");
    }

    upsertMeta("twitter:card", "summary_large_image", "name");
    upsertMeta("twitter:title", finalTitle, "name");
    upsertMeta("twitter:description", finalDescription, "name");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", finalCanonical);
  }, [title, description, image, type, canonical, site, siteSettingsMap]);

  return null;
}